import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { GLOBAL_CONSTANTS } from './core/constants/global.constant';

export const routes: Routes = [
  // Public routes
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/auth/unauthorized/unauthorized.component')
        .then(m => m.UnauthorizedComponent),
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./features/auth/forbidden/forbidden.component')
        .then(m => m.ForbiddenComponent),
  },

  // Protected shell routes
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/shell/shell.component').then(m => m.ShellComponent),
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/routes').then(m => m.DASHBOARD_ROUTES),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/routes').then(m => m.USER_ROUTES),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./features/reports/routes').then(m => m.REPORT_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/routes').then(m => m.SETTINGS_ROUTES),
      },
      {
        path: 'request',
        loadComponent: () =>
          import('./features/request/request.component').then(m => m.RequestComponent),
      },
      {
        path: 'temporary-card',
        canActivate: [roleGuard],
        data: { roles: ['SITE_ADMIN', 'ADMIN_ASSOCIATE'] },
        loadComponent: () =>
          import('./features/temporary-card/temporary-card.component').then(m => m.TemporaryCardComponent),
      },
      {
        path: 'card-management',
        canActivate: [roleGuard],
        data: { roles: ['ADMIN_ASSOCIATE'] },
        loadComponent: () =>
          import('./features/card-management/card-management.component').then(m => m.CardManagementComponent),
      },
      {
        path: 'admin',
        canActivate: [roleGuard],
        data: { roles: ['HR_ADMIN'] },
        loadChildren: () =>
          import('./features/admin/routes').then(m => m.ADMIN_ROUTES),
      },
      {
        path: 'access-management',
        canActivate: [roleGuard],
        data: { roles: ['SITE_ADMIN'] },
        loadChildren: () =>
          import('./features/access-management/routes').then(m => m.ACCESS_MANAGEMENT_ROUTES),
      },
      {
        path: 'goals',
        loadChildren: () =>
          import('./features/goals/routes').then(m => m.GOAL_ROUTES),
      },
      {
        path: '',
        redirectTo: GLOBAL_CONSTANTS.DEFAULT_ROUTE,
        pathMatch: 'full',
      },
      {
        path: 'review',
        loadChildren: () =>
          import('./features/review/routes').then(m => m.REVIEW_ROUTES),
      },
    ],
  },

  // Fallback
  { path: '**', redirectTo: '/auth/login' },
];
